// Translated
// Migrated
<template>
  <ScreenWidthProvider
    v-slot="{ isWider }"
    class="hotel-preview-gallery"
  >
    <div
      ref="featuredImage"
      class="hotel-preview-gallery__image"
      :class="{ clickable: clickableGallery }"
      @click="clickableGallery && $emit('open-gallery')"
    >
      <ResponsiveHotelImage
        :image="featuredImg"
        preferred-size="xlarge"
        :alt="hotel?.meta?.PropertyName"
      />
    </div>
    <HotelPreviewGalleryThumbnails
      v-if="isWider('md')"
      class="grid hotel-gallery-lg"
      :thumbnail-images="images.slice(1, 5)"
      @open-gallery="$emit('open-gallery')"
    />
    <HotelPreviewGalleryThumbnails
      v-else
      class="grid hotel-gallery-sm"
      :thumbnail-images="images.slice(1, 3)"
      @open-gallery="$emit('open-gallery')"
    />
  </ScreenWidthProvider>
</template>

<script>
import charterHotelMixin from '@layers/web/mixins/charter-hotel.mixin'

export default defineNuxtComponent({
  name: 'HotelPreviewGallery',

  mixins: [charterHotelMixin],

  props: {
    hotel: {
      type: Object,
      required: true,
    },

    clickableGallery: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      failed: false,
    }
  },

  emits: ['open-gallery'],

  methods: {
    // setFeaturedImageToFallback () {
    //   this.$refs.featuredImage.style.backgroundImage = `url('${this.imageSize(this.featuredImg, 'thumbnail')}')`
    // },
  },
})
</script>
